import { createContext, useContext, useEffect, useState } from 'react';
import api from './api';

const PHONE_MAP_IMG =
  'https://customer-assets-v7afamib.emergentagent.net/job_cni-inmobiliaria/artifacts/93eeaa85659854fd_Imagen%20de%20ChatGPT%2020%20oct%202026%2C%2017_50_34-1.png';
const PHONE_PROPERTY_IMG =
  'https://customer-assets-v7afamib.emergentagent.net/job_cni-inmobiliaria/artifacts/c353ddc09dc49baf_Imagen%20de%20ChatGPT%2020%20oct%202026%2C%2017_50_34-2.png';

export const DEFAULT_SITE_CONFIG = {
  menu: [
    { label: 'Inicio', to: '/', visible: true },
    { label: 'Propiedades', to: '/propiedades', visible: true },
    { label: 'Mapa', to: '/mapa', visible: true },
    { label: 'Nosotros', to: '/nosotros', visible: true },
    { label: 'Beneficios', to: '/beneficios', visible: true },
    { label: 'Membresías', to: '/membresias', visible: true },
    { label: 'Capacitación', to: '/capacitacion', visible: true },
    { label: 'Eventos', to: '/eventos', visible: true },
    { label: 'Noticias', to: '/noticias', visible: true },
    { label: 'Contacto', to: '/contacto', visible: true },
  ],
  sections: [
    { id: 'hero', label: 'Hero principal', visible: true },
    { id: 'marquee', label: 'Cinta de cámaras', visible: true },
    { id: 'stats', label: 'Barra de estadísticas', visible: true },
    { id: 'benefits', label: 'Beneficios', visible: true },
    { id: 'connect', label: 'Próximo evento', visible: true },
    { id: 'shorts', label: 'Shorts / Reels / TikToks', visible: true },
    { id: 'news', label: 'Noticias destacadas', visible: true },
    { id: 'modules', label: 'Módulos', visible: true },
    { id: 'events', label: 'Eventos destacados', visible: true },
    { id: 'trainings', label: 'Capacitaciones destacadas', visible: true },
    { id: 'cta', label: 'Banner final (CTA)', visible: true },
  ],
  news_section: {
    eyebrow: 'Sala de prensa',
    title: 'Últimas noticias del sector',
    description: 'Anuncios institucionales, análisis de mercado y novedades de la red CNIB.',
  },
  hero: {
    eyebrow: 'CNIB Connect',
    lines: ['Conectamos personas,', 'impulsamos propiedades,', 'desarrollamos futuro.'],
    subtitle: 'La red inmobiliaria más grande y colaborativa de Bolivia.',
    cta_primary: 'Hágase socio',
    cta_secondary: 'Conoce más',
    bg_image:
      'https://customer-assets-v7afamib.emergentagent.net/job_cni-inmobiliaria/artifacts/0efefdebd3049002_Panor%C3%A1mica%20urbana%20al%20atardecer.png',
    phone_map: PHONE_MAP_IMG,
    phone_property: PHONE_PROPERTY_IMG,
    features: [
      { icon: 'TrendingUp', text: 'Más oportunidades para tu negocio' },
      { icon: 'Users', text: 'Una comunidad que te impulsa' },
      { icon: 'Building2', text: 'Un sector inmobiliario más fuerte para Bolivia' },
    ],
  },
  marquee: [
    'CÁMARA INMOBILIARIA SANTA CRUZ',
    'CÁMARA INMOBILIARIA LA PAZ',
    'CÁMARA INMOBILIARIA COCHABAMBA',
    'CÁMARA INMOBILIARIA TARIJA',
    'CÁMARA INMOBILIARIA CHUQUISACA',
    'CÁMARA INMOBILIARIA BENI',
    'CÁMARA INMOBILIARIA ORURO',
    'CÁMARA INMOBILIARIA POTOSÍ',
    'CÁMARA INMOBILIARIA PANDO',
  ],
  stats: [
    { value: 1200, prefix: '+', label: 'Socios Activos', icon: 'Users' },
    { value: 8500, prefix: '+', label: 'Propiedades Publicadas', icon: 'BarChart3' },
    { value: 50000, prefix: '+', label: 'Contactos Generados', icon: 'Handshake' },
    { value: 9, prefix: '', label: 'Departamentos Representados', icon: 'Map' },
  ],
  benefits: {
    eyebrow: '¿Por qué ser socio CNIB?',
    title: 'Beneficios que impulsan tu crecimiento profesional',
    description:
      'Conecta, aprende, accede a herramientas exclusivas y forma parte de una red que transforma el sector inmobiliario de Bolivia.',
    items: [
      { icon: 'Users', title: 'Red de contactos nacional', text: 'Conecta con corredores, empresas e inversionistas en todo Bolivia.' },
      { icon: 'GraduationCap', title: 'Capacitación continua', text: 'Accede a cursos, certificaciones y eventos exclusivos.' },
      { icon: 'BarChart3', title: 'Herramientas profesionales', text: 'Tecnología, IA, CRM, mapa colaborativo y más para tu negocio.' },
      { icon: 'ShieldCheck', title: 'Credibilidad y respaldo', text: 'Forma parte de la institución más representativa del sector inmobiliario.' },
      { icon: 'Megaphone', title: 'Visibilidad y oportunidades', text: 'Publica propiedades, genera leads y crece con nuestra comunidad.' },
    ],
  },
  connect: {
    eyebrow: 'App Web',
    title: 'CNIB CONNECT',
    subtitle: 'Tu mundo inmobiliario en la palma de tu mano.',
    checklist: ['Feed profesional', 'Mapa colaborativo', 'Chat IA especializado', 'Notificaciones push', 'Y mucho más…'],
    qr_text: 'Escanea para usar la App Web',
    card_title: 'Propiedades, conexiones y oportunidades sin límites.',
    card_text:
      'Explora el mapa colaborativo, publica tus propiedades, conecta con otros profesionales y haz crecer tu negocio desde cualquier lugar.',
    card_cta: 'Conoce la plataforma',
  },
  modules: {
    eyebrow: 'Todo lo que necesitas, en un solo lugar',
    title: 'Módulos CNIB Connect',
    description: 'Herramientas diseñadas para profesionales inmobiliarios, reunidas en una sola plataforma.',
    items: [
      { id: 'feed', title: 'Feed Profesional', description: 'Noticias, consultas, oportunidades y más.', icon: 'Newspaper', color: 'from-blue-500 to-indigo-600', tag: 'Comunidad', visible: true },
      { id: 'map', title: 'Mapa Colaborativo', description: 'Propiedades, tendencias, proyectos y eventos en tiempo real.', icon: 'MapPin', color: 'from-emerald-500 to-teal-600', tag: 'Geolocalización', visible: true },
      { id: 'ai-chat', title: 'Chat IA Inmobiliario', description: 'Asistente inteligente entrenado en leyes, normativas y más.', icon: 'Bot', color: 'from-purple-500 to-violet-600', tag: 'IA Integrada', visible: true },
      { id: 'directory', title: 'Directorio de Socios', description: 'Buscador nacional de corredores y empresas.', icon: 'Users', color: 'from-amber-500 to-orange-600', tag: 'Directorio', visible: true },
      { id: 'microsite', title: 'Micrositio Personal', description: 'Tu propia web inmobiliaria profesional.', icon: 'Globe', color: 'from-pink-500 to-rose-600', tag: 'Branding', visible: true },
      { id: 'properties', title: 'Mis Propiedades', description: 'Publica y administra tus propiedades de venta o alquiler.', icon: 'Building2', color: 'from-cyan-500 to-blue-600', tag: 'Inventario', visible: true },
      { id: 'opportunities', title: 'Oportunidades', description: 'Bolsa de negocios, inversionistas y colaboraciones.', icon: 'Handshake', color: 'from-orange-500 to-red-600', tag: 'Inversión', visible: true },
      { id: 'campus', title: 'Campus Virtual', description: 'Cursos, certificaciones y capacitaciones exclusivas.', icon: 'GraduationCap', color: 'from-indigo-500 to-purple-600', tag: 'Formación', visible: true },
      { id: 'legal', title: 'Biblioteca Legal', description: 'Contratos, formatos y documentos listos para usar.', icon: 'FileText', color: 'from-slate-600 to-slate-800', tag: 'Normativa', visible: true },
      { id: 'observatory', title: 'Observatorio Inmobiliario', description: 'Indicadores, reportes y análisis del mercado.', icon: 'LineChart', color: 'from-teal-500 to-emerald-700', tag: 'Data', visible: true },
    ],
  },
  cta: {
    title: 'Tecnología, comunidad y oportunidades para hacer crecer tu negocio.',
    text: 'Únete a la red que transforma el mercado inmobiliario de Bolivia.',
    button: 'Hágase socio',
    image:
      'https://images.pexels.com/photos/16960662/pexels-photo-16960662.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    pillars: [
      { icon: 'ShieldCheck', label: 'Ética profesional' },
      { icon: 'GraduationCap', label: 'Capacitación continua' },
      { icon: 'Sparkles', label: 'Innovación y tecnología' },
      { icon: 'Landmark', label: 'Representatividad nacional' },
    ],
  },
  footer: {
    about:
      'La red inmobiliaria más grande y colaborativa de Bolivia. Conectamos personas, impulsamos propiedades y desarrollamos futuro en los 9 departamentos del país.',
    address: 'Calle 6 Este, Equipetrol — Santa Cruz de la Sierra, Bolivia',
    phone: '+591 3 344 4000',
    email: 'info@cnib.bo',
    web: 'www.cnib.bo',
  },
  social: {
    instagram: 'https://www.instagram.com/cnib.bo/',
    facebook: 'https://www.facebook.com/CNIB.BO',
    tiktok: 'https://www.tiktok.com/@cnibolivia',
    linkedin: '',
    youtube: '',
    twitter: '',
  },
  shorts: {
    enabled: true,
    position: 'after_event', // after_event | before_news | before_cta
    eyebrow: 'En redes',
    title: 'Shorts, Reels y TikToks de CNIB',
    subtitle: 'Mantente al día con nuestras cápsulas rápidas de contenido inmobiliario.',
    items: [],
  },
};

function mergeConfig(base, override) {
  if (!override || typeof override !== 'object') return base;
  const out = { ...base };
  for (const key of Object.keys(override)) {
    const b = base ? base[key] : undefined;
    const o = override[key];
    if (b && typeof b === 'object' && !Array.isArray(b) && o && typeof o === 'object' && !Array.isArray(o)) {
      out[key] = mergeConfig(b, o);
    } else {
      out[key] = o;
    }
  }
  return out;
}

const SiteConfigContext = createContext(DEFAULT_SITE_CONFIG);

export function SiteConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_SITE_CONFIG);
  useEffect(() => {
    api
      .get('/site-config')
      .then(({ data }) => {
        if (data && Object.keys(data).length > 0) {
          const merged = mergeConfig(DEFAULT_SITE_CONFIG, data);
          // Garantiza que las secciones nuevas (shorts, etc.) estén presentes incluso si el admin guardó una versión anterior
          const savedIds = new Set((merged.sections || []).map((s) => s.id));
          for (const def of DEFAULT_SITE_CONFIG.sections) {
            if (!savedIds.has(def.id)) merged.sections.push({ ...def });
          }
          setConfig(merged);
        }
      })
      .catch(() => {});
  }, []);
  return <SiteConfigContext.Provider value={config}>{children}</SiteConfigContext.Provider>;
}

export function useSiteConfig() {
  return useContext(SiteConfigContext);
}

export { mergeConfig };
